export default __webpack_public_path__ + "static/media/sap-localization-logo.657ea168.svg";